import { render, staticRenderFns } from "./AddRoostersToTournament.vue?vue&type=template&id=14a75e1c"
import script from "./AddRoostersToTournament.vue?vue&type=script&lang=js"
export * from "./AddRoostersToTournament.vue?vue&type=script&lang=js"
import style0 from "./AddRoostersToTournament.vue?vue&type=style&index=0&id=14a75e1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports